<section class="content">
  <form [formGroup]="keywordSearchForm">
    <div class="row">
      <div class="col-12 col-md-4 eachSec">
        <div class="inpSec">
          <label class="inpLabel" for="">Member's first name</label>
          <input type="text" formControlName="firstName" class="dp-input-control searchInput"
            placeholder="Enter first name" />
        </div>
      </div>
      <div class="col-12 col-md-4 eachSec">
        <div class="inpSec">
          <label class="inpLabel" for="">Member's middle name</label>
          <input type="text" formControlName="middleName" class="dp-input-control searchInput"
            placeholder="Enter middle name" />
        </div>
      </div>
      <div class="col-12 col-md-4 eachSec">
        <div class="inpSec">
          <label class="inpLabel" for="">Member's last name</label>
          <input type="text" formControlName="lastName" class="dp-input-control searchInput"
            placeholder="Enter last name" />
        </div>
      </div>
      <div class="col-12 col-md-4 eachSec">
        <div class="inpSec">
          <label class="inpLabel" for="">Ritwik’s first name</label>
          <input type="text" formControlName="ritwiki_first_name" class="dp-input-control searchInput"
            placeholder="Enter first name" [matAutocomplete]="auto" />
          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
            @for (ritwik of ritwikNames ; track ritwik) {
            <mat-option (click)="automatedDropVal(ritwik)" [value]="ritwik">{{
              ritwik
              }}</mat-option>
            }
          </mat-autocomplete>
        </div>
      </div>
      <div class="col-12 col-md-4 eachSec">
        <div class="inpSec">
          <label class="inpLabel" for="">Ritwik’s middle name</label>
          <input type="text" [readonly]="isReadonly" class="dp-input-control searchInput"
            [ngClass]="isReadonly ? 'readonlyInp' : ''" formControlName="ritwiki_middle_name"
            placeholder="Enter middle name" />
        </div>
      </div>
      <div class="col-12 col-md-4 eachSec">
        <div class="inpSec">
          <label class="inpLabel" for="">Ritwik’s last name</label>
          <input type="text" [readonly]="isReadonly" formControlName="ritwiki_last_name"
            class="dp-input-control searchInput" [ngClass]="isReadonly ? 'readonlyInp' : ''"
            placeholder="Enter last name" />
        </div>
      </div>
      <div class="col-12 col-md-4 eachSec">
        <div class="inpSec">
          <label class="inpLabel" for="">Guardian’s first name</label>
          <input type="text" class="dp-input-control searchInput" formControlName="guardian_first_name"
            placeholder="Enter first name" />
        </div>
      </div>
      <div class="col-12 col-md-4 eachSec">
        <div class="inpSec">
          <label class="inpLabel" for="">Guardian’s middle name</label>
          <input type="text" class="dp-input-control searchInput" formControlName="guardian_middle_name"
            placeholder="Enter middle name" />
        </div>
      </div>
      <div class="col-12 col-md-4 eachSec">
        <div class="inpSec">
          <label class="inpLabel" for="">Guardian’s last name</label>
          <input type="text" class="dp-input-control searchInput" formControlName="guardian_last_name"
            placeholder="Enter last name" />
        </div>
      </div>
      <div class="col-12 col-md-4 eachSec">
        <div class="inpSec">
          <label class="inpLabel" for="">Initiation date</label>
          <dp-datepicker formControlName="mship_date" placeholderLevel="dd/mm/yyyy"
            datePickerClass="datepicker"></dp-datepicker>
        </div>
      </div>
      <div class="col-12 col-md-8 eachSec">
        <div class="inpSec">
          <label class="inpLabel" for="">Address</label>
          <input type="text" formControlName="address" class="dp-input-control searchInput"
            placeholder="Enter address" />
        </div>
        <div class="errorSec" *ngIf="
              getControl('address')?.errors && getControl('address')?.touched
            ">
          <!-- <small
              class="error-message"
              *ngIf="getControl('address')?.errors?.['minlength'] || formValidationError"
              >Adress must be at least 10 characters</small
            > -->
        </div>
      </div>
      <div class="col-12 col-md-4 eachSec">
        <div class="inpSec">
          <label class="inpLabel" for="">Pincode</label>
          <input type="text" class="dp-input-control searchInput" formControlName="pinCode" placeholder="Enter PIN code"
            (keyup)="onEnteringPincode()" />
        </div>
      </div>
      <div class="col-12 col-md-4 eachSec">
        <div class="inpSec d-flex flex-column">
          <label class="inpLabel" for="">State</label>

          @if(isStateReadonly){
          <input type="text" [readOnly]="isStateReadonly" class="dp-input-control searchInput bgReadonly"
            formControlName="state_name" placeholder="Select State" />
          } @else{
          <mat-form-field class="select-mat-form-field">
            <mat-select name="state" id="state" (selectionChange)="getDistrictList($event)" formControlName="state_name"
              placeholder="Select State">
              <mat-option *ngFor="let state of stateList" [value]="state.stateName">
                {{ state.stateName }}
              </mat-option>
            </mat-select>
            <button mat-icon-button *ngIf="keywordSearchForm.get('state_name')?.value" matSuffix
              (click)="clearStateSelection($event)" class="clear-button">
              <mat-icon class="clear-icon">clear</mat-icon>
            </button>
          </mat-form-field>
          }
        </div>
      </div>
      <div class="col-12 col-md-4 eachSec">
        <div class="inpSec d-flex flex-column">
          <label class="inpLabel" for="">District</label>

          @if(isDistrictReadonly){
          <input type="text" [readOnly]="isDistrictReadonly" class="dp-input-control searchInput bgReadonly"
            formControlName="district_name" placeholder="Select district" />
          } @else {
          <mat-form-field class="select-mat-form-field">
            <mat-select name="district" id="district" formControlName="district_name" placeholder="Select District">
              <mat-option *ngFor="let district of districtList" [value]="district.district_name">
                {{ district.district_name }}
              </mat-option>
            </mat-select>
            <button mat-icon-button *ngIf="keywordSearchForm.get('district_name')?.value" matSuffix
              (click)="clearDistrictSelection($event)" class="clear-button">
              <mat-icon class="clear-icon">clear</mat-icon>
            </button>
          </mat-form-field>
          }
        </div>
      </div>
      <div class="col-6 eachSec">
        <div class="submitSec">
          <button type="reset" (click)="onclickClear()" class="clearBtn dp-secondary-btn">
            Clear
          </button>
        </div>
      </div>
      <div class="col-6 eachSec">
        <div class="submitSec">
          @if(isMobileDevice){
          <button type="submit" class="bprimary dp-primary-btn" (click)="loadMoreData(true)">
            Search
          </button>
          } @else {
          <button type="submit" class="bprimary dp-primary-btn" (click)="loadMoreData(true)">
            Search
          </button>
          }
        </div>
      </div>
    </div>
  </form>
</section>

<div class="tableBoxMob mt-4">
  @if(datatable.length>0){
  <div infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="1" [infiniteScrollThrottle]="1000"
    (scrolled)="loadMoreData(false)">
    @for( lists of datatable; track lists){
    <ul class="eachdataList">
      <li class="data">
        Sl.No <span class="serial-no" (click)="onCellClick(lists.mk)">{{ lists.mk }}</span>
      </li>
      <li class="data">
        Status<span>{{ lists.rs }}</span>
      </li>
      <li class="data">
        District <span>{{ lists.dn }}</span>
      </li>
      <li class="data">
        Name <span>{{ lists.fullName }}</span>
      </li>
      <li class="data">
        Guardian <span>{{ lists.guardianName }}</span>
      </li>
      <li class="data">
        Initiation date <span>{{ lists.md }}</span>
      </li>
      <li class="data">
        Ritwik <span>{{ lists.rn }}</span>
      </li>
      <li class="data">
        Address <span>{{ lists.add }}</span>
      </li>
    </ul>
    }
  </div>
  }@else {
  <div class="noData mt-5 d-flex justify-content-center flex-column align-items-center">
    <div class="placeholderTable"></div>
    <p>No data found!</p>
  </div>
  }

</div>